import { H5, H6 } from "@sellar-io/components";
import { SupplierListResponseType } from "@sellar-io/api-v2/types";
import { ReactElement } from "react";
import { Icon, ProfilePicture } from "../../../../components";

import OrderFulfillmentIndicator from "../../../order/orderFulfillmentIndicator/OrderFulfillmentIndicator";
import { RenderConnectionDeliveryArea } from "../RenderConnectionDeliveryArea";

export function NonConnectedSupplierListItem({
  supplier,
}: {
  supplier: SupplierListResponseType[number];
}): ReactElement {
  return (
    <div className="flex items-center gap-2">
      <ProfilePicture
        name={supplier.Business.name}
        logoUrl={supplier.Business.logoUrl}
      />
      <div className="flex flex-col">
        <div className="flex flex-row items-center gap-2">
          <H5 className="title">{supplier.Business.name}</H5>
          {supplier.DeliveryArea ? (
            <RenderConnectionDeliveryArea
              deliveryArea={supplier.DeliveryArea}
            />
          ) : (
            <OrderFulfillmentIndicator
              fulfillmentType={
                supplier.isSellarDistributionAvailable
                  ? "sellarDistribution"
                  : "courier"
              }
            />
          )}
        </div>
        <div className="flex">
          <H6>
            <Icon icon={"MAP_MARKER"} />
          </H6>
          <H6>
            {supplier.Business.DeliveryAddress.city},{" "}
            {supplier.Business.DeliveryAddress.postalCode}
          </H6>
        </div>
      </div>
    </div>
  );
}
